import React from "react";
import "./StatusModal.css";

const StatusModal = ({ open, type, message, subtext, onClose }) => {
  if (!open) return null;

  const isSuccess = type === "success";

  return (
    <div className="status-modal-overlay">
      <div className="status-modal">
        <img
          src={
            isSuccess
              ? "/images/success-status.png"
              : "/images/error-status.png"
          }
          alt="status"
          className="status-icon"
        />

        <h3>{message}</h3>
        <p>{subtext}</p>

        <button onClick={onClose}>OK</button>
      </div>
    </div>
  );
};

export default StatusModal;